import makeStyles from '@mui/styles/makeStyles'
import { defaultPalette } from '../../../theme/idsTheme'

export default makeStyles((theme) => ({
    Header: {
        position: 'fixed',
        top: 0,
        right: 0,
        left: 0,
        zIndex: 900,
        height: '4.5rem',
        background: '#ffffff',
        padding: '.5rem 1rem',
        boxShadow: '0px 1px 18px rgba(221,225,236,0.6)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    HeaderLeft: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up('md')]: {
            gap: '3.5rem',
        },
    },
    HeaderLogo: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '1rem',
    },
    HeaderTitle: {
      fontFamily: 'AvertaPE-Bold',
      fontSize: '1.3rem',
      fontWeight: 700,
      letterSpacing: '0.15px',
    },
    HeaderInitTeleexpertiseButton: {
      borderRadius: '8px',
      padding: '12px 32px',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '12px',
      color: '#FB355D',
      background: '#FBF4F6',
      display: 'flex',
      '&:hover': {
        background: defaultPalette.red.hover,
        color: defaultPalette.white.main,
      },
      // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
      [theme.breakpoints.down('sm')]: {
          width: '48px',
          height: '48px',
          padding: 0,
          '& .MuiSvgIcon-root': {
              fontSize: '24px',
          },
      },
    },
    HeaderAppName: {
        display: 'none',
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up('md')]: {
            display: 'flex',
            fontSize: '.95rem',
            fontWeight: 700,
            color: defaultPalette.typography.main,
            textDecoration: 'none',
        },
    },
    HeaderNavigation: {},
    HeaderNavigationInner: {
        display: 'none',
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up('md')]: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: '.5rem',
        },
    },
    HeaderNavigationItem: {
        textDecoration: 'none',
        fontWeight: 600,
        color: defaultPalette.typography.main,
        padding: '.3rem 1.2rem',
        '&:hover': {
            opacity: 0.7,
        },
    },
    HeaderNavigationItemActive: {
        background: defaultPalette.typography.main,
        color: '#ffffff',
        borderRadius: 100,
    },
    HeaderRight: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: '1rem',
    },
    HeaderUserMenuButton: {
        color: defaultPalette.typography.main,
        fontWeight: 600,
        justifyContent: 'center',
    },
    HeaderUserMenuIcon: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    HeaderUserMenuFullname: {
        display: 'none',
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up('md')]: {
            display: 'flex',
        },
    },
    HeaderUserMenuButtonName: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        fontSize: '.9rem',
        lineHeight: '.9rem',
        textTransform: 'initial',
    },
    HeaderUserMenuContent: {},
    HeaderUserMenuUser: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '1rem',
        background: defaultPalette.lightGrey.dark,
        padding: '1rem',
        borderRadius: '9px',
        marginBottom: '2rem',
    },
    HeaderUserMenuItems: {
        cursor: 'pointer',
    },
    HeaderUserMenuItemsGroup: {
        '&::before': {
            display: 'none',
        },
    },
    HeaderUserMenuItemsGroupSeparator: {
        background: defaultPalette.lightGrey.dark,
        borderRadius: 100,
        height: '1px',
        width: '100%',
    },
    HeaderUserMenuItemsTitle: {},
    HeaderUserMenuItemsGroupTitleText: {
        fontSize: '0.8rem',
        color: defaultPalette.typography.light,
    },
    HeaderUserMenuItemsGroupTitle: {
        padding: '1.5rem 1rem',
        borderBottom: 'none',
        '& .MuiAccordionSummary-content': {
            margin: 0,
        },
    },
    HeaderUserMenuItemsGroupContent: {
        padding: '0',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'column',
        gap: '1.5rem',
    },
    HeaderUserMenuItemsGroupContentList: {
        width: '100%',
    },
    HeaderUserMenuItem: {
        color: 'initial',
    },
    HeaderUserMenuItemIcon: {
        width: '1.25rem',
        height: '1.25rem',
        marginLeft: '.25rem',
    },
    HeaderHcsSwitchButton: {
        color: defaultPalette.typography.main,
        border: `2px solid ${defaultPalette.typography.main}`,
        padding: '.3rem .7rem',
        borderRadius: '100px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '.5rem',
    },
    HeaderHcsSwitchButtonLabel: {
        fontSize: '.8rem',
        transform: 'translateY(2px)',
        display: 'none',
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up('sm')]: {
            display: 'flex',
        },
    },
    HeaderHcsSwitchPaper: {
        maxWidth: '22rem',
    },
    HeaderHcsSwitchBackdrop: {
        background: 'rgba(252, 251, 254, 0.98)',
        opacity: '1 !important',
    },
    HeaderUserMenuLogout: {
        marginTop: '3rem',
        width: '100%',
    },
    HeaderUserMenuLogoutButton: {
        width: '100%',
        background: defaultPalette.red.main,
        color: '#ffffff',
        '&:hover': {
            background: defaultPalette.red.hover,
        },
    },
    HeaderNavigationPopover: {
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    HeaderNavigationPopoverButton: {
        color: defaultPalette.typography.main,
    },
    HeaderNavigationPopoverPaper: {
        width: '100%',
    },
    HeaderNavigationPopoverItems: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'column',
        width: '100%',
    },
    HeaderNavigationPopoverItem: {
        color: defaultPalette.typography.main,
        textDecoration: 'none',
        fontWeight: 600,
        width: '100%',
        padding: '1rem 0',
    },
    HeaderNavigationPopoverItemActive: {
        color: defaultPalette.typography.light,
    },
    HeaderRightHelpButton: {
        color: defaultPalette.typography.main,
        width: '2.25rem',
        height: '2.25rem',
    },
    HeaderLogOutButton: {
        minWidth: '7rem',
        padding: '0.75rem 2.125rem',
        background: defaultPalette.red.main,
        color: defaultPalette.white.main,
        '&:hover': {
            background: defaultPalette.red.hover,
        },
    },
}))
